import {createApp, reactive} from "petite-vue";
import PhoneCodeInput from "../components/phone-code-input";
import Search from "../components/form/search";

export default function initCv(): void {
    const cvForm = document.querySelector('[data-cv-edit]')
    if (!cvForm) return

    const cv: CvStore = reactive({
        include_degree: document.querySelector<HTMLInputElement>('input[type="checkbox"][name="include_degree"]')?.checked ?? false,
        removeUploadedPhoto(e) {
            const closer = e.target as HTMLElement
            closer.closest('.Alert').remove()
        },
        createFieldset(e) {
            const button = e.target as HTMLElement,
                template = button.parentElement.querySelector('template')

            if (!template) return

            const repeater = button.previousElementSibling,
                fieldset = template.content.cloneNode(true) as DocumentFragment

            fieldset.children[0].innerHTML = fieldset.children[0].innerHTML
                .replaceAll('__index__', repeater.childElementCount.toString())

            fieldset.children[0].querySelector('button')?.addEventListener('click', this.removeFieldset)
            fieldset.children[0].querySelector('[data-field-disabler]')?.addEventListener('change', this.handleFieldsDisabler)
            fieldset.children[0].querySelector('[data-specialization-select]')?.addEventListener('change', this.handleProfessionsSelect)

            repeater.appendChild(fieldset)
        },
        removeFieldset(e) {
            const closer = e.target as HTMLElement,
                fieldset = closer.closest('fieldset'),
                section = closer.closest('section')

            if (fieldset.nextElementSibling)
                fieldset.innerHTML = ''
            else
                fieldset.remove()

            section.classList.contains('UserPanelSection--expandable')
                && !section.querySelectorAll('fieldset:not(:empty)').length
                && section.classList.remove('is-expanded')
        },
        handleFieldsDisabler(e) {
            const check = e.target as HTMLInputElement
            check.closest('fieldset').querySelectorAll('[data-disablable-field]').forEach(field => {
                field.toggleAttribute('disabled', check.checked)
                if (check.checked && field.hasAttribute('required')) {
                    field.removeAttribute('required')
                    field.setAttribute('data-required', '')
                } else if (field.hasAttribute('data-required')) {
                    field.setAttribute('required', '')
                }
            })
        },
        handleProfessionsSelect(e) {
            const specializationsSelect = e.target as HTMLSelectElement,
                professionsSelect = specializationsSelect.closest('.FormFieldGroup').querySelector('select[name*="profession"]') as HTMLSelectElement

            professionsSelect.disabled = !specializationsSelect.value
            professionsSelect.value = ''
            Array.from(professionsSelect.options).forEach(option => {
                option.disabled = !!option.value && option.dataset.specialization !== specializationsSelect.value
            })
        },
        expandSection(e) {
            const section = (e.target as HTMLElement).closest('section')
            section.classList.add('is-expanded')

            const fieldsetCreator = section.querySelector('.FormRepeater-fieldsetCreator')
            fieldsetCreator && !section.querySelectorAll('.FormRepeater fieldset').length
                && fieldsetCreator.dispatchEvent(new Event('click'))
        },
        collapseSection(e) {
            const section = (e.target as HTMLElement).closest('section')
            section.classList.remove('is-expanded')

            section.querySelectorAll<HTMLInputElement>(':is(input, select)')
                .forEach(field => { field.value = field.defaultValue })

            section.querySelectorAll<HTMLInputElement>('input[type="checkbox"]')
                .forEach(field => { field.checked = false })

            section.querySelectorAll<HTMLTextAreaElement>('textarea')
                .forEach(field => { field.innerHTML = '' })

            section.querySelector<HTMLButtonElement>('[data-reset-fieldset]')?.dispatchEvent(new Event('click'))
        },
        beforeSubmit(e) {
            history.replaceState(null, document.title, window.location.pathname + window.location.search)
        }
    })

    cvForm.querySelectorAll(':is(input, select)').forEach(field => {
        field.addEventListener('focus', (e: FocusEvent) => {
            (e.relatedTarget as HTMLElement)?.getAttribute('type') === "submit" && window.scrollBy(0, -80)
        })
    })

    cvForm.querySelectorAll(':is(input, select):disabled:required').forEach(field => {
        field.removeAttribute('required')
        field.setAttribute('data-required', '')
    })

    createApp({ PhoneCodeInput, Search, cv }).mount(cvForm)

    cvForm.querySelectorAll('section').forEach(section => {
        if (section.id !== window.location.hash.replace('#', '')) return

        window.scrollTo({ top: window.scrollY - 48, left: 0, behavior: "instant" })
        section.querySelector('.UserPanelSection-expandableButton button')?.dispatchEvent(new Event('click'))
    })
}
